import React, { useState } from "react";
import { Modal, Button, Table, Row, Col } from "react-bootstrap";
import { ICONS } from "../../constants/constants";
import { useDispatch } from "react-redux";

import AddTaskModal from "../../pages/AddTaskModel";
import EditTaskModal from "../../pages/EditTaskModal";
import { handleDeleteTask, handleEditSchedualer } from "../../store/actions/scheduallerActions";

const SchedualerDetailsModal = ({
  show,
  handleClose,
  schedualerData,
  setSchedualerData,
  productList,
}) => {
  const dispatch = useDispatch();
  const [showAddModal, setShowAddModal] = useState(false);
  const [editTaskData, setEditTaskData] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [deletedTask, setDeletedTask] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);

  // utils/dateFormatter.js
 const formatDate = (dateString, format = "year") => {
  const date = new Date(dateString);
  if (isNaN(date)) return "N/A";

  const options =
    format === "year"
      ? { year: "numeric" }
      : format === "full"
      ? { day: "numeric", month: "short", year: "numeric" }
      : {}; // Default fallback

  return new Intl.DateTimeFormat("en-US", options).format(date);
};


  const handleDeleteTaskClick = (task) => {
    setDeletedTask(task);
    setConfirmModal(true);
  };

  // const confirmDelete = async () => {
  //   await dispatch(handleDeleteTask(schedualerData?.schedualer?.id, deletedTask.task_id));
  //   setConfirmModal(false);
  //   setDeletedTask(null);
  // };

  const confirmDelete = async () => {
  if (!schedualerData?.schedualer?.id || !deletedTask?.task_id) return;

  await dispatch(handleDeleteTask(schedualerData.schedualer.id, deletedTask.task_id));

  // 🔹 Remove task from local state so UI refreshes
  setSchedualerData((prev) => {
    if (!prev?.schedualer?.tasks) return prev;
    return {
      ...prev,
      schedualer: {
        ...prev.schedualer,
        tasks: prev.schedualer.tasks.filter((t) => t.task_id !== deletedTask.task_id),
      },
    };
  });

  setConfirmModal(false);
  setDeletedTask(null);
};


  // const handleSaveEditedTask = async (updatedTask) => {
  //   if (!schedualerData?.schedualer?.id || !updatedTask?.task_id) return;
  //   const formData = { task_id: updatedTask.task_id, updatedTask };
  //   await handleEditSchedualer(schedualerData.schedualer.id, formData, dispatch);
  //   setShowEditModal(false);
  // };

  const handleSaveEditedTask = async (updatedTask) => {
  if (!schedualerData?.schedualer?.id || !updatedTask?.task_id) return;

  const formData = { task_id: updatedTask.task_id, updatedTask };
  await handleEditSchedualer(schedualerData.schedualer.id, formData, dispatch);

  // 🔹 Update task in local state
  setSchedualerData((prev) => {
  if (!prev?.schedualer?.tasks) return prev;
  return {
    ...prev,
    schedualer: {
      ...prev.schedualer,
      tasks: prev.schedualer.tasks.map((t) =>
        t.task_id === updatedTask.task_id
          ? {
              ...t,
              ...updatedTask,
              assigned_date: updatedTask.assigned_date || updatedTask.date_assigned || t.assigned_date,
              due_date: updatedTask.due_date || t.due_date,
            }
          : t
      ),
    },
  };
});


  setShowEditModal(false);
};


const renderTasks = () => {
  const tasks = schedualerData?.schedualer?.tasks || [];

  if (!tasks.length) {
    return (
      <tr>
        <td colSpan="9">No tasks added yet.</td>
      </tr>
    );
  }
return tasks.map((task, index) => {
  const productNames = [];
  const productQuantities = [];

  (task?.products || []).forEach((prod) => {
    const product = productList?.find(
      (p) => p.id === prod.productId || p._id === prod.productId
    );
    if (product) {
      productNames.push(product.productName || product.product_name || "Unnamed Product");
      productQuantities.push(prod.quantityPerAcre || 0);
    }
  });

  // If there are no products, still render at least one row
  const hasProducts = productNames.length > 0;
  const rowsToRender = hasProducts ? productNames.length : 1;

  return (
    <>
      {Array.from({ length: rowsToRender }).map((_, idx) => (
        <tr key={`${task.task_id || `task-${index}`}-${idx}`}>
          {/* Only display task info in the first row */}
          {idx === 0 && (
            <>
              <td rowSpan={rowsToRender}>{task.task_id || index + 1}</td>
              <td rowSpan={rowsToRender}>{task.task_category || "N/A"}</td>
              <td rowSpan={rowsToRender}>{task.task_description || "N/A"}</td>
              <td rowSpan={rowsToRender}>{task.assigned_date || "N/A"}</td>
              <td rowSpan={rowsToRender}>{task.due_date || "N/A"}</td>
            </>
          )}

          {/* Product name and quantity */}
          <td>{hasProducts ? productNames[idx] : "—"}</td>
          <td>{hasProducts ? productQuantities[idx] : "—"}</td>

          {/* Only display actions in the first row */}
          {idx === 0 && (
            <td rowSpan={rowsToRender}>
              <Row>
                <Col>
                  <Button
                    variant="link"
                    className="p-0 border-0 bg-transparent"
                    onClick={() => {
                      setEditTaskData(task);
                      setShowEditModal(true);
                    }}
                  >
                    <img src={ICONS.editIcon} className="faPlusIcon" alt="edit" />
                  </Button>
                </Col>
                <Col>
                  <Button
                    variant="link"
                    className="p-0 border-0 bg-transparent"
                    onClick={() => handleDeleteTaskClick(task)}
                  >
                    <img src={ICONS.deleteIcon} className="faPlusIcon" alt="delete" />
                  </Button>
                </Col>
              </Row>
            </td>
          )}
        </tr>
      ))}
    </>
  );
});


};





  return (
    <>
      <Modal show={show} onHide={handleClose} fullscreen>
        <Modal.Header closeButton>
          <Modal.Title>
             {schedualerData?.schedualer?.schedualerName || "Crop Scheduler Details"}
          </Modal.Title>
        </Modal.Header>
      <Modal.Body>
     <Table
    className="mb-4"
    style={{
      maxWidth: "100%",
      backgroundColor: "transparent",
      border: "none",
      gap: "10px",
    }}
  >
    <thead style={{ backgroundColor: "transparent", border: "none" }}>
      <tr>
       {/* No title for image */}
        <th style={{ border: "none" }}></th>
        <th style={{ border: "none", backgroundColor: "transparent" }}>Crop Name</th>
        <th style={{ border: "none", backgroundColor: "transparent" }}>Region</th>
        <th style={{ border: "none", backgroundColor: "transparent" }}>No of Tasks</th>
        <th style={{ border: "none", backgroundColor: "transparent" }}>Start Date</th>
        <th style={{ border: "none", backgroundColor: "transparent" }}>End Date</th>
      </tr>
    </thead>
    <tbody>
      <tr style={{ backgroundColor: "transparent", border: "none" }}>
        <td rowSpan={2} style={{ verticalAlign: "middle", border: "none", }}>
          <img
            src={
              schedualerData?.schedualer?.crop?.crop_image ||
              "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/product.png"
            }
            alt="crop"
            style={{
              width: 60,
              height: 60,
              borderRadius: "50%",
              objectFit: "cover",
               marginTop: "-40px"
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src =
                "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/product.png";
            }}
          />
        </td>
        <td style={{ border: "none" }}>
          {schedualerData?.schedualer?.crop?.crop_name || "N/A"}
        </td>
        <td style={{ border: "none" }}>
          {schedualerData?.schedualer?.region?.region || "N/A"}
        </td>
        <td style={{ border: "none" }}>
          {schedualerData?.schedualer?.tasks?.length || 0}
        </td>
        <td style={{ border: "none" }}>
          {schedualerData?.schedualer?.tasks?.[0]?.assigned_date || "N/A"}
        </td>
        <td style={{ border: "none" }}>
          {
            schedualerData?.schedualer?.tasks?.[
              schedualerData?.schedualer?.tasks?.length - 1
            ]?.due_date || "N/A"
          }
        </td>
      </tr>
      <tr style={{ backgroundColor: "transparent", border: "none" }}>
        {/* Spacer row under image */}
        <td colSpan={5} style={{ border: "none" }}></td>
      </tr>
    </tbody>
  </Table>

  <Row className="mb-3">
    <Col md={6}>
      <h5>Tasks</h5>
    </Col>
    <Col md={6} className="text-end">
      <Button className="button" onClick={() => setShowAddModal(true)}>
        <img src={ICONS.addPlusIcon} className="faPlusIcon" alt="Add" /> Add New Task
      </Button>
    </Col>
  </Row>

  <Table
    striped hover responsive
  style={{ backgroundColor: "transparent", border: "none" }}
  className="custom-task-table"
  >
    <thead>
      <tr>
        <th>No</th>
        <th>Category</th>
        <th>Description</th>
        <th>Start Date</th>
        <th>End Date</th>
        <th>Products</th>
        <th>Qty/Acre</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>{renderTasks()}</tbody>
  </Table>
</Modal.Body>

      </Modal>

      {/* Add Task */}
      <AddTaskModal
        show={showAddModal}
        handleClose={() => setShowAddModal(false)}
        productList={productList}
        selectedCropScheduallerData={schedualerData}
        setSelectedCropScheduallerData={setSchedualerData}
      />

      {/* Edit Task */}
      <EditTaskModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        task={editTaskData}
        schedualerId={schedualerData?.schedualer?.id}
        productList={productList}
        onSave={handleSaveEditedTask}
      />

      {/* Delete Confirm Modal */}
      <Modal show={confirmModal} onHide={() => setConfirmModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Task</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete task <b>{deletedTask?.task_description}</b>?
        </Modal.Body>
        <Modal.Footer>
          <Button className="reject-button" onClick={() => setConfirmModal(false)}>
            Cancel
          </Button>
          <Button className="button" onClick={confirmDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SchedualerDetailsModal;
